import React, { useContext, useEffect, useState } from 'react';
import { Money, MoneyContent, CloseButton, MoneyPopup, HiddenButton } from './MoneyModal.styles';
import { ModalContext } from 'core/modal';
import IMAGES from 'assets/images';

declare const window: any;

interface Props {
  onRedirect: () => void;
}

export const MoneyModal: React.FunctionComponent<Props> = ({
    onRedirect,
}) => 
{
    const { close } = useContext(ModalContext);
    const [ isLoading, setIsLoading ] = useState<boolean>(true);

    useEffect(() => 
    {
        setIsLoading(false);
    }, [ setIsLoading ]);

    useEffect(() => 
    {
        const _hsq = window._hsq;
        _hsq.push([ 'refreshPageHandlers' ]);
    }, []);


    return (
        <Money>
            <MoneyContent className={isLoading ? '' : 'fade-in'}>
                <CloseButton onClick={close} />
                <MoneyPopup src={IMAGES.moneyPopup} alt="popup" />
                <HiddenButton id='Backend-Start-Investing-Continue-CIDI' onClick={onRedirect} type="button">Continue to Direct Investing</HiddenButton>
            </MoneyContent>
        </Money>
    );
};
